import './AboutContact.css';

const FEATURES = [
  { icon: '✓', text: 'Lisanslı & Sigortalı Ekip' },
  { icon: '✓', text: 'Garantili İşçilik' },
  { icon: '✓', text: 'Şeffaf Fiyatlandırma' },
  { icon: '✓', text: '7/24 Acil Müdahale' },
  { icon: '✓', text: 'Kaliteli Malzeme Kullanımı' },
];

const INFO = [
  { icon: '📞', label: 'Telefon',        value: '0546 931 46 01', href: 'tel:+905469314601' },
  { icon: '📧', label: 'E-posta',        value: 'akistesisatist1@gmail.com', href: 'mailto:akistesisatist1@gmail.com' },
  { icon: '📍', label: 'Konum',          value: 'Kağıthane, İstanbul', href: 'https://maps.google.com/?q=Kağıthane,İstanbul' },
  { icon: '🕐', label: 'Çalışma',        value: '7/24 Acil Servis', href: null },
];

function AboutContact() {
  return (
    <section id="hakkimizda" className="ac">
      <div className="ac__glow" />

      <div className="ac__inner">

        {/* SOL — Hakkımızda */}
        <div className="ac__about">
          <span className="ac__tag">Hakkımızda</span>
          <h2 className="ac__title">
            Biz<br /><span className="ac__title-accent">Kimiz?</span>
          </h2>

          <p className="ac__text">
            2004 Yılından günümüze kadar bir çok sektöre web hizmetleri veren uzman ekibimiz bir çok isimle ön plana çıkmıştır. Tüm bu zaman zarfı içinde kusursuz müşteri memnuniyeti sağlamayı başaran ve çizgisini hiç bozmayan ekibimizle yıllaca süregelen bu web hizmetlerinde artık marka oluşumuna girmiş bulunmaktayız tüm teknoloji ve gelişimi kalbinde büyüten ve sürekli gelişen ekip tecrübesiyle artık ismimin Son Yazılım Bilişim hizmetleri olarak siz değerli müşterilerine web sektöründe öncü yenilikleri sunmaktan gurur duyarız.
          </p>

          <p className="ac__text">
            Kurulduğu günden itibaren hiç vazgeçmediği bir kaç çizgiden en önemlisi ise <strong>destek anlayışımızdır!</strong> Tüm bu hizmetler yanında sürekli müşterilerini arayan sorun yaşadıkları bir konu olup olmadığını soran destek ekibimiz ile sürekli kazandığımız müşteri portfoyü ile on binlerce müşteri sayısına ulaşmış bulunmaktayız!
          </p>

          <p className="ac__text">
            Değerli vaktinizi bizi tanımaya ayırdığınız için çok teşekkür ederiz! Umarız bizi tanımanızda yardımcı olabilmişizdir, biz yinede yeterli gelmemiştir diye bizi iletişim sayfamızdaki telefon numaramızdan arayıp bir kaç soru sormanızı bekleyen arkadaşlarımız olduğunu hatırlatalım ve iyi günler dileyelim...
          </p>

          <div className="ac__quality">
            <div className="ac__quality-title">Kalite Anlayışımız</div>
            <p className="ac__quality-text">
              Yazılım veya hizmetin tarafımızdan talep edilmesi ile ürünün size teslimine kadar tüm amacımız kaliteyi beklentilerinizin üzerinde tutmaktır. Tüm kalite anlayışını şu şekilde özetleyebiliriz;
            </p>
            <div className="ac__quality-badge">
              "Müşteriye istediği hizmeti istediği gibi doğru ve tam zamanında ulaştırmaktır!"
            </div>
          </div>

          <div className="ac__features">
            {FEATURES.map(f => (
              <div key={f.text} className="ac__feat">
                <span className="ac__feat-check">✓</span>
                <span>{f.text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ORTA — Dikey ayraç */}
        <div className="ac__divider" />

        {/* SAĞ — Bize Ulaşın */}
        <div className="ac__contact" id="iletisim">
          <span className="ac__tag">Bize Ulaşın</span>
          <h2 className="ac__title">
            Hemen<br /><span className="ac__title-accent">İletişime</span> Geç
          </h2>
          <div className="ac__info-list">
            {INFO.map(({ icon, label, value, href }) => (
              <div key={label} className="ac__info-item">
                <div className="ac__info-icon">{icon}</div>
                <div>
                  <div className="ac__info-label">{label}</div>
                  {href
                    ? <a href={href} className="ac__info-link">{value}</a>
                    : <div className="ac__info-value">{value}</div>}
                </div>
              </div>
            ))}
          </div>
          <a href="tel:+905469314601" className="ac__cta">
            Şimdi Ara — 0546 931 46 01
          </a>
        </div>

      </div>
    </section>
  );
}

export default AboutContact;
